import { UAParser } from 'ua-parser-js'

/**
 * Function to check if the current browser user agent is a bot.
 * Uses `UAParser` to parse the browser details and checks if the
 * browser type is a known bot (e.g., 'crawler', 'fetcher').
 *
 * @returns {boolean} - Returns true if the browser is identified as a bot.
 */
export const isBot = () => {
  // Initialize UAParser to parse the user agent string
  const uaParser = new UAParser()

  // Retrieve browser information from the parsed user agent string
  const browser = uaParser.getBrowser()

  // Get the browser type (if available) or default to an empty string
  const browserType = browser.type ?? ''

  /**
   * List of known bot types based on UAParser's documentation.
   * Reference: https://docs.uaparser.dev/list/browser/type.html#browser-type
   * Examples of bot types:
   * - 'crawler': Automated bots used to crawl and index websites (e.g., Googlebot)
   * - 'fetcher': Bots that retrieve specific URLs to generate previews
   *              or extract metadata (e.g., Twitterbot)
   */
  const botTypes = ['crawler', 'fetcher']

  // Return true if the browser type matches one of the known bot types
  return botTypes.includes(browserType)
}
